import React from "react";
import EducationBannerimg from "../../assets/img/inner-banner/Education.webp";
import EducationBannerMobileimg from "../../assets/img/mobile-banner/Education.webp";

import { Container } from "react-bootstrap";
const EducationBanner = () => {
  return (
    <>
      <section>
        <Container fluid className="bannersection position-relative p-0">
          <img
            src={
              window.innerWidth > 568
                ? EducationBannerimg
                : EducationBannerMobileimg
            }
            alt="Service banner"
            className="w-100 h-100 object-fit-cover about-banner-img"
          />
        </Container>
      </section>
    </>
  );
};

export default EducationBanner;
